import PropTypes from 'prop-types';

const BoxesWithText = ({ backgroundColor, color, children, className }) => (
  <div
    className={className}
    style={{
      backgroundColor,
      color,
      fontWeight: '600',
      lineHeight: 'initial'
    }}
  >
    {children}
  </div>
);

BoxesWithText.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  className: PropTypes.string
};

BoxesWithText.defaultProps = {
  backgroundColor: '#F5F5F5',
  color: '#000',
  className: ''
};

export default BoxesWithText;
